"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _style = _interopRequireDefault(require("../style.css"));
var _bin = _interopRequireDefault(require("cccisd-icons/bin"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var DndDeleteButton = function DndDeleteButton(_ref) {
  var onClick = _ref.onClick;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(_style["default"].dndArrows, " ").concat(_style["default"].dndDeleteButton)
  }, /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    onClick: onClick
  }, /*#__PURE__*/_react["default"].createElement(_bin["default"], null)));
};
var _default = exports["default"] = DndDeleteButton;